/**
 * BookingTypeFetcher
 *
 * @author Dec Norton <decnorton@gmail.com>
 */
import { Fetcher } from '../../fetchers/fetcher';

class BookingTypeFetcher extends Fetcher {
    get modelName() {
        return 'Booking Type';
    }

    get resourceName() {
        return 'booking-types';
    }
}

export function bookingTypeFetcherProvider() {
    this.$get = instantiateFetcher;

    instantiateFetcher.$inject = ['$injector'];

    function instantiateFetcher($injector) {
        return $injector.instantiate(BookingTypeFetcher);
    }
}
